module.exports = __webpack_public_path__ + "img/mrsmith-desktop.236178ad.jpg";